// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/workerClassification.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9178: ONE W-2 / 1099 worker-classification rule, client + server.)
//
// Side-effect module: attaches `window.WorkerClass`. Every reader of a person's
// W-2 / 1099 status calls `window.WorkerClass.resolve(person)` — never the raw
// `workerType` / `taxClassification` fields — and every write goes through
// `window.WorkerClass.write(value)`. A window global read at CALL time, never a
// cross-`?v=` ES import (Pitfall #1).
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  /** Every value the authoritative `taxClassification` field may hold. */
  const WORKER_CLASSES = ['employee', 'contractor', 'owner_operator'];

  /** The two values the legacy, derived `workerType` field may hold. */
  const LEGACY_WORKER_TYPES = ['employee', 'contractor'];

  /**
   * UI labels. `owner_operator` is the 1099 LEASED DRIVER who owns his rig — it
   * is NOT the carrier's owner (TASK-9181 keeps those two apart on purpose).
   */
  const WORKER_CLASS_LABELS = {
    employee: 'Employee (W-2)',
    contractor: 'Contractor (1099)',
    owner_operator: 'Owner-Operator (1099)',
  };

  function _wcPick(value, allowed) {
    if (typeof value !== 'string') return null;
    const v = value.trim();
    return allowed.indexOf(v) >= 0 ? v : null;
  }

  function _wcPresent(value) {
    return !(value === null || value === undefined || (typeof value === 'string' && value.trim() === ''));
  }

  /** True for the 1099 classes. null / unknown → false. */
  function isWorkerClass1099(classification) {
    return classification === 'contractor' || classification === 'owner_operator';
  }

  /** The derived legacy `workerType` value for a classification (null when unset). */
  function workerTypeFor(classification) {
    if (classification === 'employee') return 'employee';
    if (isWorkerClass1099(classification)) return 'contractor';
    return null;
  }

  /**
   * THE resolver. Returns:
   *   classification  'employee' | 'contractor' | 'owner_operator' | null (nobody decided)
   *   is1099 / isW2   booleans off `classification` (both false when unset)
   *   explicit        someone chose a classification (false = unset)
   *   source          'taxClassification' | 'workerType' (legacy fallback) | null
   *   conflict        both raw fields set and on OPPOSITE sides of W-2 / 1099
   *   invalid         raw field names holding a value this rule does not know
   *   inSync          the stored pair is exactly what workerClassWrite() would write
   */
  function resolveWorkerClass(person) {
    const p = person || {};
    const tc = _wcPick(p.taxClassification, WORKER_CLASSES);
    const wt = _wcPick(p.workerType, LEGACY_WORKER_TYPES);
    const invalid = [];
    if (_wcPresent(p.taxClassification) && !tc) invalid.push('taxClassification');
    if (_wcPresent(p.workerType) && !wt) invalid.push('workerType');

    let classification = null;
    let source = null;
    if (tc) { classification = tc; source = 'taxClassification'; }
    // LEGACY FALLBACK — Chris's decision 2026-09-25: a person with ONLY the old
    // `workerType` still COUNTS as that classification everywhere. Do not ignore
    // the old field. Consequence accepted on deploy: 4 active trippin-trucking
    // people with only workerType='employee' now join the QBO employee sync and
    // the W-2 roster CSV.
    else if (wt) { classification = wt; source = 'workerType'; }

    const conflict = !!(tc && wt && isWorkerClass1099(tc) !== isWorkerClass1099(wt));
    const storedWt = _wcPresent(p.workerType) ? p.workerType : null;
    const storedTc = _wcPresent(p.taxClassification) ? p.taxClassification : null;
    const inSync = invalid.length === 0 && storedTc === tc && storedWt === workerTypeFor(tc);

    return {
      classification: classification,
      is1099: isWorkerClass1099(classification),
      isW2: classification === 'employee',
      explicit: classification !== null,
      source: source,
      conflict: conflict,
      invalid: invalid,
      inSync: inSync,
    };
  }

  /**
   * The ONLY shape a classification write may take: both fields from one value.
   * '' / null / undefined clears both. Anything else not in WORKER_CLASSES throws
   * — a typo must never become a third, unreadable state.
   */
  function workerClassWrite(classification) {
    const c = _wcPresent(classification) ? String(classification).trim() : null;
    if (c !== null && WORKER_CLASSES.indexOf(c) < 0) {
      throw new Error('workerClassWrite: unknown worker classification ' + JSON.stringify(classification));
    }
    return { taxClassification: c, workerType: workerTypeFor(c) };
  }

  /**
   * What a SAVE on a screen that shows the classification control should write.
   * `chosen` is the control's value ('' = unset); `touched` is true only when the
   * user actually changed the control on this edit.
   *
   *   • chosen differs from the resolved value      → write the pair (a real change)
   *   • same value, user explicitly picked it, and the stored pair is not in sync
   *     (conflict / legacy one-field record)         → write the pair (a deliberate confirm)
   *   • otherwise                                    → null: leave BOTH fields untouched
   *
   * An unrelated save (FLSA, pay, cards) must never resolve a conflict on the
   * user's behalf — the CLASS CONFLICT flag stays visible until someone picks.
   * (TASK-9178 COD round 2.)
   */
  function classificationWriteForSave(person, chosen, touched) {
    // The "— confirm —" placeholder (classificationSelectModel) means the user
    // made NO choice: never a write, never a clear.
    if (chosen === WORKER_CLASS_UNCONFIRMED) return null;
    const r = resolveWorkerClass(person);
    const c = _wcPresent(chosen) ? String(chosen).trim() : null;
    if (c !== r.classification) return workerClassWrite(c);
    if (touched === true && !r.inSync) return workerClassWrite(c);
    return null;
  }

  /** Placeholder option value: "the stored pair is not confirmed yet". */
  const WORKER_CLASS_UNCONFIRMED = '__confirm__';

  /**
   * Inline `onchange` for every classification <select>: marks a DELIBERATE pick.
   * One string so the HR screens and the tests run the exact same handler.
   */
  const WORKER_CLASS_SELECT_ONCHANGE = "this.dataset.touched='1'";

  /**
   * What a classification <select> shows. TASK-9178 COD r3: a record whose stored
   * pair is not in sync (a conflict, or only one of the two fields set) opens on
   * a "— Confirm classification —" placeholder instead of pre-selecting the
   * resolved value. Re-selecting an already-shown option fires no change event,
   * so pre-selecting made such a record impossible to confirm; from the
   * placeholder, picking ANY real value — including the current one — is one
   * deliberate action that fires change and writes the pair. Leaving the
   * placeholder writes nothing (classificationWriteForSave).
   *
   * Returns { selected, options: [{ value, label }], needsConfirm }.
   * `unsetLabel` labels the '' (unset) option.
   */
  function classificationSelectModel(person, unsetLabel) {
    const r = resolveWorkerClass(person);
    const options = [{ value: '', label: unsetLabel }];
    for (let i = 0; i < WORKER_CLASSES.length; i++) {
      options.push({ value: WORKER_CLASSES[i], label: WORKER_CLASS_LABELS[WORKER_CLASSES[i]] });
    }
    const needsConfirm = !r.inSync;
    if (needsConfirm) {
      const now = r.classification ? WORKER_CLASS_LABELS[r.classification] : 'not set';
      options.unshift({
        value: WORKER_CLASS_UNCONFIRMED,
        label: '— Confirm classification (currently treated as ' + now + (r.conflict ? '; records disagree' : '') + ') —',
      });
    }
    return { selected: needsConfirm ? WORKER_CLASS_UNCONFIRMED : (r.classification || ''), options: options, needsConfirm: needsConfirm };
  }

  /** Label for a classification ('—' style fallback is the caller's call). */
  function workerClassLabel(classification, fallback) {
    return WORKER_CLASS_LABELS[classification] || (fallback === undefined ? '' : fallback);
  }

  /**
   * The classification fields a Payroll Prep row carries (clock.js
   * buildPayrollPrepData → payroll.js buildGustoRows). `workerType` on the ROW is
   * the export gate: 'contractor' rows never enter the Gusto employee import.
   * Unset still exports as W-2 (blocking payroll over one unclassified person
   * traps everybody) — `workerTypeExplicit: false` drives the UNCLASSIFIED badge.
   */
  function payrollRowWorkerClass(person) {
    const r = resolveWorkerClass(person);
    return {
      workerType: r.is1099 ? 'contractor' : 'employee',
      workerTypeExplicit: r.explicit,
      workerClass: r.classification,
      workerClassConflict: r.conflict,
    };
  }

  window.WorkerClass = Object.freeze({
    CLASSES: WORKER_CLASSES.slice(),
    LABELS: Object.freeze(Object.assign({}, WORKER_CLASS_LABELS)),
    is1099: isWorkerClass1099,
    workerTypeFor: workerTypeFor,
    resolve: resolveWorkerClass,
    write: workerClassWrite,
    writeForSave: classificationWriteForSave,
    selectModel: classificationSelectModel,
    UNCONFIRMED: WORKER_CLASS_UNCONFIRMED,
    SELECT_ONCHANGE: WORKER_CLASS_SELECT_ONCHANGE,
    label: workerClassLabel,
    payrollRow: payrollRowWorkerClass
  });
})();
